import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

interface MessageSummaryCardProps {
    handleViewMore: () => void;
    heading: string;
    description?: string;
}
const MessagesSummaryCard: FC<
    React.PropsWithChildren<MessageSummaryCardProps>
> = ({ heading, handleViewMore, description, children }) => {
    return (
        <Container>
            <SubContainer>
                <HeadingContainer>
                    <Heading>{heading}</Heading>
                    <Button onClick={handleViewMore}>View messages</Button>
                </HeadingContainer>
                {description && <Description>{description}</Description>}
            </SubContainer>
            <ChildrenContainer>{children}</ChildrenContainer>
        </Container>
    );
};
export default MessagesSummaryCard;

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '180px',
    backgroundColor: aampeTheme.colors.white,
    borderRadius: aampeTheme.borderRadius.default,
    padding: aampeTheme.spacing(3, 3, 4, 3),
    gap: aampeTheme.spacing(3),
});

const SubContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(1),
});

const HeadingContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});

const Heading = styled.text({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
});

const Description = styled.text({
    color: aampeTheme.colors.neutral09,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
});

const Button = styled.text({
    color: aampeTheme.colors.solidA01,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '18px',
    cursor: 'pointer',
});
const ChildrenContainer = styled.div({
    fontSize: '32px',
    fontWeight: 500,
    color: aampeTheme.colors.textAccessibleWG02,
});
